<template>
  <div>
    <div v-if="!stats || !stats.length" class="tw-text-muted">No stats</div>
    <div v-else class="tw-overflow-x-auto">
      <table class="bk-table bk-table--compact">
        <thead>
          <tr>
            <th>Batch timestamp</th>
            <th>Result</th>
            <th>Error</th>
            <th>Started</th>
            <th>Ended</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <template v-for="purgeSource of stats">
            <tr :key="purgeSource.id">
              <td><display-datetime :datetime="convertBatchIdToTimestamp(purgeSource.batch_id)" /></td>
              <td>
                <StatusIcon
                  :ok="purgeSource.result === 'success'"
                  :title="purgeSource.result === 'success' ? 'All resources were fully purged' : 'Not all resources were fully purged'"
                />
              </td>
              <td>{{ purgeSource.error }}</td>
              <td><display-datetime :datetime="convertBatchIdToTimestamp(purgeSource.created_at)" /></td>
              <td><display-datetime :datetime="convertBatchIdToTimestamp(purgeSource.updated_at)" /></td>
              <td>
                <Button
                  :label="purgeSource.id in expanded ? 'Hide' : 'Detail'"
                  class="p-button-text p-button-sm"
                  @click="expand(purgeSource.id)"
                />
              </td>
            </tr>
            <tr v-if="purgeSource.id in expanded" :key="purgeSource.id + '-detail'">
              <td colspan="6">
                <div class="tw-px-4 tw-py-3">
                  <table class="bk-table">
                    <thead>
                      <tr>
                        <th colspan="2" />
                        <th :colspan="purgeSource.resources[0].destinations.length" class="tw-text-center">
                          Num records purged from destination
                        </th>
                      </tr>
                      <tr>
                        <th>Resource</th>
                        <th>Status</th>
                        <th
                          v-for="destination of purgeSource.resources[0].destinations"
                          :key="destination.name"
                          class="tw-text-center"
                        >
                          {{ destination.name }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="resource of purgeSource.resources" :key="resource.name">
                        <td>{{ resource.name }}</td>
                        <td class="tw-text-center">
                          <StatusIcon
                            :ok="resource.is_done"
                            :title="resource.is_done ? 'All destinations were fully purged' : 'Not all destinations were fully purged'"
                          />
                        </td>
                        <td
                          v-for="destination of resource.destinations"
                          :key="destination.name"
                          class="tw-text-right"
                        >
                          <div>{{ destination.num_records_purged }}</div>
                          <div class="tw-text-xs tw-text-muted">
                            IDs: {{ destination.ids_purged.join(', ') }}
                            <i
                              class="pi pi-question-circle tw-ml-1"
                              v-tooltip="'This is usually a subset and is meant more as proof than the full list'"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { convertBatchIdToTimestamp } from '../../lib/sync/utils/datetime'
import StatusIcon from './StatusIcon'

export default {
  components: { StatusIcon },
  props: {
    stats: Array,
  },
  data() {
    return { expanded: {} }
  },
  methods: {
    convertBatchIdToTimestamp,
    expand(sourceId) {
      if (sourceId in this.expanded) {
        this.$delete(this.expanded, sourceId)
        return
      }
      this.$set(this.expanded, sourceId, true)
    },
  },
}
</script>
